// React libraries
import React from "react";
// Custom Styles
import { useStyles } from "./ListOfOrderPositionsPageStyles";
// Material-UI Core
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
// Icon
import Edit from "../../../icons/Edit/Edit";
import { BlueGradientHeader } from "../../index";
import { PageWrapper } from "../../index";
import { GreyButton } from "../../index";
import { WhiteContentBar } from "../../index";
import { KeyboardCompleteModal } from "../../index";
import { BlueLink } from "../../index";
import { AllowScanGs1128Modal } from "../../index";
import { DraftDocumentModal } from "../../index";
export const ListOfOrderPositionsPage = (props) => {
    const classes = useStyles(props);
    const { previewWidth, previewHeight, templateType, warehouseLayout, data, allowEditBpRefNo, completeOrderType, quickCheck, newPositionAddable, headerTitle, allowScanGS1128, draftDocumentSetting, subtitle, name } = props;
    let bpRefNoHeight;
    if (allowEditBpRefNo) {
        bpRefNoHeight = 40;
    }
    else {
        bpRefNoHeight = 0;
    }
    const [bpRefNo, setBpRefNo] = React.useState("");
    const [isKeyboardBpRefNoModalOpen, setIsKeyboardBpRefNoModalOpen] = React.useState(false);
    const [listData, setListData] = React.useState(data);
    let isConfirmed = false;
    if (completeOrderType === "atLeastOnePosition") {
        let tempStatusConfirmed = false;
        listData.map((data) => {
            if (data.open === data.covered) {
                tempStatusConfirmed = true;
            }
        });
        if (tempStatusConfirmed) {
            isConfirmed = true;
        }
        else {
            isConfirmed = false;
        }
    }
    else {
        let tempStatusConfirmed = true;
        listData.map((data) => {
            if (data.open !== data.covered) {
                tempStatusConfirmed = false;
            }
        });
        if (tempStatusConfirmed) {
            isConfirmed = true;
        }
        else {
            isConfirmed = false;
        }
    }
    const editListData = (data) => {
        let tempListData = [...listData];
        tempListData.map((tempData) => {
            if (tempData.id === data.id) {
                if (tempData.open === tempData.covered) {
                    tempData.covered = 0;
                }
                else {
                    tempData.covered = tempData.open;
                }
            }
        });
        setListData(tempListData);
    };
    const allowScanData = {
        nveSscc: "1122111112111112111",
        item: "110002222",
        description: "LeMon 4029 PrintHead",
        quantity: 5,
        batch: "20202022",
        bbd: "12022012"
    };
    // Close Dialog On Option Change
    React.useEffect(() => {
        setIsKeyboardBpRefNoModalOpen(false);
    }, [templateType, warehouseLayout, allowEditBpRefNo, completeOrderType, quickCheck, newPositionAddable]);
    return (React.createElement(PageWrapper, { previewHeight: previewHeight, previewWidth: previewWidth },
        React.createElement(Grid, { container: true },
            React.createElement(Grid, { item: true, md: 12 },
                React.createElement(BlueGradientHeader, { type: "smallWithSub", showScanner: true, previewHeight: previewHeight },
                    React.createElement("p", null, headerTitle),
                    React.createElement("sub", null,
                        subtitle,
                        " - ",
                        React.createElement("b", null, "2334")))),
            React.createElement(Grid, { item: true, md: 12, className: classes.whiteContentTopRadius, style: { height: previewHeight - 90 - 50 + 10 } },
                React.createElement(Grid, { container: true },
                    React.createElement(Grid, { item: true, md: 12 },
                        React.createElement(WhiteContentBar, { data: {
                                leftContent: "Positions",
                                rightContent: "4"
                            } })),
                    allowEditBpRefNo && (React.createElement(Grid, { item: true, md: 12 },
                        React.createElement(WhiteContentBar, { data: {
                                leftContent: "BP Ref. No.",
                                rightContent: bpRefNo,
                                rightIcon: Edit
                            }, onClick: () => { setIsKeyboardBpRefNoModalOpen(!isKeyboardBpRefNoModalOpen); } }))),
                    templateType === "templateA" && (React.createElement(Grid, { item: true, md: 12, className: classes.listOrderItemsDiv, style: { height: previewHeight - 90 - 50 - 40 - bpRefNoHeight + 10 } },
                        React.createElement(Grid, { container: true, className: classes.listOrderItemsContainer },
                            listData.map((orderItem) => (React.createElement(Button, { className: classes.listOrderItemsButton },
                                React.createElement(Grid, { item: true, md: 12 },
                                    React.createElement(Grid, { container: true },
                                        React.createElement(Grid, { item: true, md: 5 },
                                            React.createElement(Grid, { container: true },
                                                React.createElement(Grid, { className: classes.listOrderItemsButtonTitle, item: true, md: 12 }, "Item"),
                                                React.createElement(Grid, { className: classes.listOrderItemsButtonLeftContent, item: true, md: 12 }, orderItem.item),
                                                React.createElement(Grid, { className: classes.listOrderItemsButtonTitle, item: true, md: 12, style: { marginTop: "5px" } }, "Open / Covered"),
                                                React.createElement(Grid, { className: classes.listOrderItemsButtonLeftContent, item: true, md: 12 }, orderItem.open + " / " + orderItem.covered + " " + orderItem.openCoveredType))),
                                        quickCheck && !orderItem.mandatoryBatchOrSerialNumber ? (React.createElement(React.Fragment, null,
                                            React.createElement(Grid, { item: true, md: 6 },
                                                React.createElement(Grid, { container: true },
                                                    React.createElement(Grid, { className: classes.listOrderItemsButtonTitle, item: true, md: 12 }, "Description"),
                                                    React.createElement(Grid, { className: classes.listOrderItemsButtonLeftContent, item: true, md: 12 }, orderItem.description),
                                                    React.createElement(Grid, { className: classes.listOrderItemsButtonTitle, item: true, md: 12, style: { marginTop: "5px" } }, "Warehouse"),
                                                    React.createElement(Grid, { className: classes.listOrderItemsButtonLeftContent, item: true, md: 12 }, warehouseLayout === "warehouseName" ? orderItem.warehouseName : orderItem.warehouseCode))),
                                            React.createElement(Grid, { container: true, item: true, md: 1, alignItems: "center", justifyContent: "flex-end" },
                                                React.createElement("input", { type: "checkbox", name: name, id: orderItem.id, checked: orderItem.open === orderItem.covered ? true : false, onChange: (e) => { editListData(orderItem); } })))) : (React.createElement(Grid, { item: true, md: 7 },
                                            React.createElement(Grid, { container: true },
                                                React.createElement(Grid, { className: classes.listOrderItemsButtonTitle, item: true, md: 12 }, "Description"),
                                                React.createElement(Grid, { className: classes.listOrderItemsButtonLeftContent, item: true, md: 12 }, orderItem.description),
                                                React.createElement(Grid, { className: classes.listOrderItemsButtonTitle, item: true, md: 12, style: { marginTop: "5px" } }, "Warehouse"),
                                                React.createElement(Grid, { className: classes.listOrderItemsButtonLeftContent, item: true, md: 12 }, warehouseLayout === "warehouseName" ? orderItem.warehouseName : orderItem.warehouseCode))))))))),
                            newPositionAddable && (React.createElement(Grid, { container: true, className: classes.whiteContentBarContainer },
                                React.createElement(Grid, { item: true, md: 12 },
                                    React.createElement(BlueLink, null, "Add New Row"))))))),
                    templateType === "templateB" && (React.createElement(React.Fragment, null,
                        React.createElement(Grid, { item: true, md: 12, className: classes.greyContentBar },
                            React.createElement(Grid, { container: true },
                                React.createElement(Grid, { className: classes.greyLeftContent, item: true, md: 5 },
                                    React.createElement("p", null, "Bin Location")),
                                React.createElement(Grid, { className: classes.greyRightContent, item: true, md: 7 },
                                    React.createElement("p", null, "Open / Covered / Warehouse")))),
                        React.createElement(Grid, { item: true, md: 12, className: classes.listOrderItemsDiv, style: { height: previewHeight - 90 - 50 - 40 - bpRefNoHeight + 10 - 35 } },
                            React.createElement(Grid, { container: true, className: classes.listOrderItemsContainer },
                                listData.map((orderItem) => (React.createElement(Button, { className: classes.listOrderItemsButton },
                                    React.createElement(Grid, { item: true, md: 12 },
                                        React.createElement(Grid, { container: true },
                                            React.createElement(Grid, { item: true, md: 6 },
                                                React.createElement(Grid, { container: true },
                                                    React.createElement(Grid, { className: classes.listOrderItemsButtonLeftContent, item: true, md: 12 }, orderItem.item),
                                                    React.createElement(Grid, { className: classes.listOrderItemsButtonLeftContent, item: true, md: 12 }, orderItem.description))),
                                            quickCheck && !orderItem.mandatoryBatchOrSerialNumber ? (React.createElement(React.Fragment, null,
                                                React.createElement(Grid, { item: true, md: 5 },
                                                    React.createElement(Grid, { container: true },
                                                        React.createElement(Grid, { className: classes.listOrderItemsButtonRightContent, item: true, md: 12 }, orderItem.open + " / " + orderItem.covered + " " + orderItem.openCoveredType),
                                                        React.createElement(Grid, { className: classes.listOrderItemsButtonRightContent, item: true, md: 12 }, warehouseLayout === "warehouseName" ? orderItem.warehouseName : orderItem.warehouseCode))),
                                                React.createElement(Grid, { container: true, item: true, md: 1, alignItems: "center", justifyContent: "flex-end" },
                                                    React.createElement("input", { type: "checkbox", name: name, id: orderItem.id, checked: orderItem.open === orderItem.covered ? true : false, onChange: (e) => { editListData(orderItem); } })))) : (React.createElement(Grid, { item: true, md: 5 },
                                                React.createElement(Grid, { container: true },
                                                    React.createElement(Grid, { className: classes.listOrderItemsButtonRightContent, item: true, md: 12 }, orderItem.open + " / " + orderItem.covered + " " + orderItem.openCoveredType),
                                                    React.createElement(Grid, { className: classes.listOrderItemsButtonRightContent, item: true, md: 12 }, warehouseLayout === "warehouseName" ? orderItem.warehouseName : orderItem.warehouseCode))))))))),
                                newPositionAddable && (React.createElement(Grid, { container: true, className: classes.whiteContentBarContainer },
                                    React.createElement(Grid, { item: true, md: 12 },
                                        React.createElement(BlueLink, null, "Add New Row")))))))))),
            React.createElement(Grid, { item: true, md: 6 },
                React.createElement(GreyButton, { onClick: () => { }, type: "left" }, "Back")),
            React.createElement(Grid, { item: true, md: 6 },
                React.createElement(GreyButton, { onClick: () => { }, type: "right", disabled: !isConfirmed }, "Add"))),
        React.createElement(KeyboardCompleteModal, { title: "BP Ref. No.", initialValue: bpRefNo, isModalOpen: isKeyboardBpRefNoModalOpen, setInitialValue: setBpRefNo, setOpenModalState: setIsKeyboardBpRefNoModalOpen }),
        React.createElement(AllowScanGs1128Modal, { data: allowScanData, isModalOpen: allowScanGS1128 }),
        draftDocumentSetting && (React.createElement(DraftDocumentModal, { draft: draftDocumentSetting.draft, isModalOpen: draftDocumentSetting.setting, modalHeight: previewHeight, modalWidth: previewWidth }))));
};
ListOfOrderPositionsPage.defaultProps = {
    subtitle: "Business Tools AG"
};
export default React.memo(ListOfOrderPositionsPage);
